import { RenderStats } from '../render/renderer.js';

/** F3-toggled performance/network diagnostics overlay. */
export class PerfOverlay {
  private el: HTMLDivElement;
  private visible = false;
  private acc = 0;

  constructor(parent: HTMLElement) {
    this.el = document.createElement('div');
    this.el.style.cssText = `position:absolute; left:10px; bottom:10px; font-family:var(--mono);
      font-size:11px; color:#8fdcff; background:rgba(5,10,18,0.82); padding:8px 12px;
      border:1px solid rgba(80,140,190,0.35); pointer-events:none; white-space:pre; display:none; z-index:150;`;
    parent.appendChild(this.el);
    window.addEventListener('keydown', (e) => {
      if (e.code === 'F3') {
        e.preventDefault();
        this.visible = !this.visible;
        this.el.style.display = this.visible ? '' : 'none';
      }
    });
  }

  update(
    stats: RenderStats,
    net: { ping: number; packetsPerSec: number; reconcileError: number; interpDelayMs: number } | null
  ): void {
    if (!this.visible) return;
    this.acc += 1;
    if (this.acc % 10 !== 0) return; // update at ~6Hz
    let text =
      `FPS ${stats.fps}  frame ${stats.frameMs.toFixed(2)}ms\n` +
      `draws ${stats.drawCalls}  tris ${(stats.triangles / 1000).toFixed(1)}k\n` +
      `ships ${stats.entities}`;
    if (net) {
      text +=
        `\nping ${net.ping}ms  pkts ${net.packetsPerSec}/s\n` +
        `reconcile ${net.reconcileError.toFixed(3)}m  interp ${net.interpDelayMs.toFixed(0)}ms`;
    }
    this.el.textContent = text;
  }
}
